/* global G */
import { curry } from 'lib/util'

/**
 * Log Submit Event Handler
 *
 * Submits the payload contained in `event` to the server.
 *
 * @param {Gaia.AppModule.Spec} module    current module
 * @param {Gaia.Component.Spec} component component that triggered the event
 * @param {Gaia.PlatformEvent} event      the event object
 * @returns {void}
 */
const logSubmit = (module, component, event) => {
  const { [G.HTTP]: httpAdapter } = module[G.MODEL][G.ADAPTER]
  const { /** @type {LogPayload} */ payload } = event?.detail || event || {}
  const { version = 1 } = module[G.MODEL][G.PROPS]

  const url = `/api/v${version}/accesslog`

  try {
    httpAdapter
      .post({ url, params: payload })
      .catch((e) => {
        console.error('Could not submit log: ', e)
      })
  } catch (e) {
    console.error('Could not submit log: ', e)
  }
}

export default curry(logSubmit)
